import { useQuery } from "@tanstack/react-query";

import { SettingsQueryKeys } from "./settingsQueryKeys";
import { getSettings } from "@/api/settings";

export const useSettings = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [SettingsQueryKeys.Settings],
    enabled: options?.enabled ?? true,
    queryFn: ({ signal }) => {
      return getSettings({ signal });
    },
  });
};
